import format from 'date-fns/format';
import { PaymentInitiatorEnum, PaymentStatusEnum, WorkingModeEnum } from 'src/features/devices/devices.types';
import { PaymentMethodEnum } from 'src/features/companies/companies.types';
import { CompanyBannerType } from 'src/features/companyBanners/companyBanners.types';
import { ServiceProviderType } from '../features/serviceProvider/types';

export const formatDatetime = (date: string): string => {
  if (!date) {
    return '-';
  }
  return format(new Date(date), 'dd.MM HH:mm:ss');
};

export const formatDate = (date: string): string => {
  if (!date) {
    return '-';
  }
  return format(new Date(date), 'dd.MM.yyyy');
};

export const formatPaymentInitiator = (data: string): string => {
  switch (data) {
    case PaymentInitiatorEnum.headset:
      return 'Шлем';
    case PaymentInitiatorEnum.desk:
      return 'Ресепшен';
    case PaymentInitiatorEnum.qr_code:
      return 'QR Код';
    default:
      return 'Не выбран';
  }
};

export const formatPaymentMethod = (data: string): string => {
  switch (data) {
    case PaymentMethodEnum.paymentSystem:
      return 'Картой по SMS/Email';
    case PaymentMethodEnum.reception:
      return 'Ресепшен';
    case PaymentMethodEnum.roomBill:
      return 'Комната';
    case PaymentMethodEnum.vipAccess:
      return 'VIP';
    default:
      return 'Неизвестный';
  }
};

export const formatWorkingMode = (data: string): string => {
  switch (data) {
    case WorkingModeEnum.inRoom:
      return 'Комната';
    case WorkingModeEnum.reception:
      return 'Ресепшен';
    case WorkingModeEnum.vipAccess:
      return 'VIP';
    default:
      return 'Неизвестный';
  }
};

export const formatPaymentStatus = (data: string): string => {
  switch (data) {
    case PaymentStatusEnum.succeeded:
      return 'Оплачен';
    case PaymentStatusEnum.pending:
      return 'Ожидает оплаты';
    case PaymentStatusEnum.canceled:
      return 'Отменен';
    default:
      return 'Неизвестный';
  }
};

export const currencySign = (currency: string): string => {
  switch (currency.toLowerCase()) {
    case 'rub':
      return '\u20BD';
    default:
      return currency;
  }
};

export const formatBannerType = (data: string): string => {
  switch (data) {
    case CompanyBannerType.AdBanner:
      return 'Рекламный';
    case CompanyBannerType.CompanyBanner:
      return 'Компании';
    case CompanyBannerType.SystemBanner:
      return 'Системный';
    default:
      return 'Неизвестный';
  }
};

export const formatServiceType = (data: string): string => {
  switch (data) {
    case ServiceProviderType.HotelService:
      return 'Отельный сервис';
    default:
      return 'Неизвестный';
  }
};
